import { Colors, Lightning } from '@lightningjs/sdk';
import TextLabel from 'components/common/TextLabel';
import AbstractContent, {
  AbstractContentTemplateSpec,
} from 'components/pages/settings/sections/contents/AbstractContent';

const TITLE_FONT_SIZE = 24;
const TITLE_LINE_HEIGHT = 22;
const DESCRIPTION_FONT_SIZE = 22;
const DESCRIPTION_LINE_HEIGHT = 30;
const DESCRIPTION_WIDTH = 800;

export default class QrCodeContent extends AbstractContent {
  static override _template(): Lightning.Component.Template<AbstractContentTemplateSpec> {
    return {
      ...super._template(),
      Heading: {
        type: TextLabel,
        text: {
          fontSize: TITLE_FONT_SIZE,
          textColor: Colors('text').get(),
          fontStyle: 'bold',
          lineHeight: TITLE_LINE_HEIGHT,
        },
      },
      Description: {
        type: TextLabel,
        text: {
          fontSize: DESCRIPTION_FONT_SIZE,
          textColor: Colors('labelText').get(),
          lineHeight: DESCRIPTION_LINE_HEIGHT,
          wordWrap: true,
          wordWrapWidth: DESCRIPTION_WIDTH,
          advancedRenderer: true,
        },
      },
    };
  }
}
